<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Question Information</h1>
          <p class="mt-2 text-sm text-gray-700">Details</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
      </div>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Question Set</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.question_set_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Business Function</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.question_section_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Parent Question</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.parent_text }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Option Group</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.option_group_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Text</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.text }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" ref="editorWrapper">
            <dt class="text-sm font-medium leading-6 text-gray-900">Description</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 trix-editor">
              <span v-html="question.description"></span>
            </dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Additional Info</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.additional_info }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Info Link</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
              <a :href="question.info_link" class="text-blue-600 visited:text-purple-600" target="_blank">{{ question.info_link }}</a>
            </dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Additional Info</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.additional_info_1 }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Info Link</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
              <a :href="question.info_link_1" class="text-blue-600 visited:text-purple-600" target="_blank">{{ question.info_link_1 }}</a>
            </dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Allow completion without scoring</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.no_score_completion }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Severity</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ question.severity_name }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
  <div class="overflow-hidden rounded-lg bg-white shadow mt-3">
    <div class="px-4 py-5 sm:p-6">
      <question-checkpoint-index-components />
    </div>
  </div>
</template>

<script>
import { PaperClipIcon } from '@heroicons/vue/20/solid'
import QuestionCheckpointIndexComponents from "../QuestionCheckpoint/QuestionCheckpointIndexComponents.vue";

export default {
  name: "QuestionShowComponent",
  data() {
    return {
      question: {
        question_set_name: null,
        question_section_name: null,
        parent_text: null,
        option_group_name: null,
        text: null,
        description: null,
        additional_info: null,
        info_link: null,
        no_score_completion: false,
        severity_name: null,
      }
    }
  },
  computed: {
    questionSetId() {
      return this.$route.params.question_set_id ? parseInt((this.$route.params.question_set_id)) : null;
    },
    questionId() {
      return this.$route.params.question_id ? parseInt((this.$route.params.question_id)) : null;
    },
  },
  components: {
    PaperClipIcon,
    QuestionCheckpointIndexComponents
  },
  methods: {
    getQuestion() {
      axios.get(`/member-firm/question-set/${this.questionSetId}/question/show/${this.questionId}`).then((res) => {
        this.question = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    cancel() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.questionId) {
      this.getQuestion();
    }
  },
  updated() {
    const editorWrapper = this.$refs.editorWrapper;
    if (editorWrapper) {
      const links = editorWrapper.querySelectorAll('.trix-editor a');
      links.forEach(link => {
        link.setAttribute('target', '_blank');
      });
    }
  }
}
</script>